export const LEVEL_META = {
  critica: { label: 'Crítica', adj: 'crítico', cls: 'bg-red-600 text-white on-solid', ring: '#dc2626', bar: 'bg-red-500' },
  alta: { label: 'Alta', adj: 'alto', cls: 'bg-orange-600 text-white on-solid', ring: '#ea580c', bar: 'bg-orange-500' },
  media: { label: 'Media', adj: 'medio', cls: 'bg-amber-300 text-amber-950', ring: '#f59e0b', bar: 'bg-amber-400' },
  baja: { label: 'Baja', adj: 'bajo', cls: 'bg-slate-300 text-slate-800', ring: '#94a3b8', bar: 'bg-slate-400' },
};
export const LEVELS = ['critica', 'alta', 'media', 'baja'];
export const OPPORTUNITY_META = {
  critica: { cls: 'bg-emerald-600 text-white on-solid', ring: '#059669', bar: 'bg-emerald-600' },
  alta: { cls: 'bg-emerald-500 text-white on-solid', ring: '#10b981', bar: 'bg-emerald-500' },
  media: { cls: 'bg-emerald-200 text-emerald-900', ring: '#34d399', bar: 'bg-emerald-400' },
  baja: { cls: 'bg-emerald-100 text-emerald-900', ring: '#6ee7b7', bar: 'bg-emerald-300' },
};
export const metaFor = (s) => ({ ...LEVEL_META[s.level], ...(s.kind === 'opportunity' ? OPPORTUNITY_META[s.level] : {}) });

export const STATUS_LABELS = { nueva: 'Nueva', reconocida: 'Reconocida', descartada: 'Descartada', resuelta: 'Resuelta' };

export const CATEGORY_LABELS = {
  schedule_slip: 'Atraso de cronograma (SPI)',
  cpm_delay: 'Ruta crítica fuera de plazo',
  critical_overdue: 'Actividad crítica vencida',
  prediction_at_risk: 'Predicción en riesgo',
  prediction_missed: 'Predicción no cumplida',
  kpi_below_benchmark: 'KPI peor que benchmark',
  kpi_forecast_breach: 'KPI cruzará el benchmark',
  slack_available: 'Holgura reasignable',
  prediction_ahead: 'Meta superable',
  kpi_above_benchmark: 'KPI mejor que benchmark',
  underused_reliable_iad: 'IAD confiable poco usada',
  reliable_agent: 'Agente muy preciso',
};

export const BREAKDOWN = [
  { key: 'magnitude', label: 'Magnitud', weight: 40 },
  { key: 'importance', label: 'Importancia', weight: 25 },
  { key: 'urgency', label: 'Urgencia', weight: 20 },
  { key: 'confidence', label: 'Confianza', weight: 15 },
];

export const RISK_OPTIONS = [
  { value: 'critical', label: 'Crítico' }, { value: 'high', label: 'Alto' },
  { value: 'medium', label: 'Medio' }, { value: 'low', label: 'Bajo' },
];
